<div class="layout-footer">
    <div class="footer-logo-container">
        <img src="/layout/images/logo-{{ isDarkTheme() ? 'white' : 'dark' }}.svg" alt="diamond-layout" />
        <span class="footer-app-name">EXPRESS ERP</span>
    </div>
    <span class="footer-copyright">&#169; Express ERP - 2026</span>
</div>
